<template>
  <v-col v-if="content" cols="12" class="d-flex justify-space-between align-center">
    <div class="d-flex align-center">
      {{ content[field] }}
    </div>
    <v-btn icon>
      <v-icon color="black" :class="[{'disable':!!session.cancelled}]" @click="deleteContenType(content)">
        mdi-minus-circle-outline
      </v-icon>
    </v-btn>
  </v-col>
</template>

<script>

export default {
  props: {
    content: {
      type: Object,
      default: null
    },
    field: {
      type: String,
      default: null
    },
    session: {
      type: Object,
      default: null
    }
  },
  setup (props, context) {
    const deleteContenType = content => {
      context.emit('deleteContent', { uuid: content.uuid, contentType: content.wtype });
    };

    return { deleteContenType };
  }
};
</script>
